import React from 'react';
import { getImageUrl } from '../../Image/utils';
import { Content, Title, Subtitle, Inner } from './partials';
export var BackgroundImageCard = function BackgroundImageCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    verticalAlign = _ref.verticalAlign,
    color = _ref.color,
    backgroundImage = _ref.backgroundImage,
    backgroundColor = _ref.backgroundColor,
    link = _ref.link;
  return React.createElement(Inner, {
    href: link,
    backgroundImage: getImageUrl(backgroundImage, {
      width: 180,
      height: 180
    }),
    backgroundColor: backgroundColor,
    "data-fi-event": link
  }, title || subtitle ? React.createElement(Content, {
    color: color || null,
    verticalAlign: verticalAlign || 'middle'
  }, title ? React.createElement(Title, {
    color: color || null
  }, title) : null, subtitle ? React.createElement(Subtitle, null, subtitle) : null) : null);
};